import { FilterFormFieldStrategyType } from "@/common/types";
import { fieldServiceTypeOptions } from "../filter-options";

const fieldServiceFilterByProduct: FilterFormFieldStrategyType[] = [
  {
    key: "Field service type",
    element: {
      inputType: "checkboxGroup",
      label: "Field service type",
      required: false,
      name: "FieldService-type",
      options: fieldServiceTypeOptions,
    },
  },
];
export default fieldServiceFilterByProduct;
